export const EditableValueTestIdFactory = {
    getEditableValueBase: () => 'editable-value',
    getEditableValueContainerBase: () => [EditableValueTestIdFactory.getEditableValueBase(), 'container'].join('-'),
    getEditableValueContainer: (fieldName) => [
        EditableValueTestIdFactory.getEditableValueContainerBase(),
        fieldName,
    ].join('-'),
    getEditableValueTrigger: (fieldName) => [EditableValueTestIdFactory.getEditableValueBase(), fieldName].join('-'),
    getEditableValueContent: (fieldName) => [
        EditableValueTestIdFactory.getEditableValueBase(),
        'content',
        fieldName,
    ].join('-'),
    getEditableValueResetToDefault: (fieldName) => [
        EditableValueTestIdFactory.getEditableValueBase(),
        'reset',
        fieldName,
    ].join('-'),
    getEditableValueDefaultLabel: (fieldName) => [
        EditableValueTestIdFactory.getEditableValueBase(),
        'default',
        'label',
        fieldName,
    ].join('-'),
};
